import { Link } from "gatsby"
import React from "react"
import Layout from "src/components/Layout"
import * as styles from "src/styles/intro.module.scss"

export default function Introduction() {
  return (
    <Layout>
      <div className="container">
        <h1 className="heading">Our Story: why we started Nenathambara</h1>
        <p className={["justified", styles.paragraph].join(" ")}>
          There are schools in various areas of Sri Lanka that do not have
          adequate support and guidance to make the improvements necessary to
          facilitate a proper IT education for students. Our objective is to
          provide the necessary physical resources as well as extra curricular
          learning resources, and to provide systematic training to teachers and
          other resource people. In the long run, we seek to improve people's
          understanding of technology.
        </p>
        <p className={["justified", styles.paragraph].join(" ")}>
          One of our main activities is to create online courses for students in
          Sinhala and Tamil, to learn programming, electronics and using
          microcontrollers, developing both conceptual knowledge as well as
          practical skills which they can use to solve simple problems and as a
          stepping stone for more sophisticated studies. We have already
          launched a{" "}
          <Link className="paragraph_link" to="/courses">
            course
          </Link>{" "}
          for the basics of programming (the Sinhala version is online and the
          Tamil version is under construction. Consider{" "}
          <Link className="paragraph_link" to="/volunteer">
            volunteering
          </Link>
          ) and are currently developing a second course in programming as well
          as a course for arduino and electronics. We develop these assuming
          simple prerequisites, with much thought on pedagogy that even students
          grade 7 and above can learn and master the material and skills. This
          is accessible free of charge to anyone.
        </p>
        <p className={["justified", styles.paragraph].join(" ")}>
          We also train teachers, conducting webinars and seminars, helping them
          to learn and master these skills. We also provide them with support to
          deliver our curricula to their students in classroom settings.
        </p>
        <p className={["justified", styles.paragraph].join(" ")}>
          With the current state of Covid we have temporarily stopped our other
          activities but will restart these as soon as conditions improve. This
          is mostly to do with the improvement of physical resources in schools.
        </p>
        <p className={["justified", styles.paragraph].join(" ")}>
          As an initial project, we have scouted out four schools in the
          Anuradhapura district, where a resource input would enhance the level
          of IT education in the area. In the process we have observed a number
          of other problems that can be solved with little extra work that would
          benefit these institutions greatly. We will paint a detailed picture
          of the current situation at these schools and what we hope to achieve.
        </p>
        <p className={["justified", styles.paragraph].join(" ")}>
          The schools were picked based on several criteria. Primarily the IT
          facilities are either non existent, outdated or are insufficient to
          cater to the student population. The schools we have picked have a
          dedicated cohort of teachers led by able Principals, who are directing
          their efforts, to improve the level of education received by the
          students in their schools. Moreover, there is a parent body who has a
          keen interest in improving these facilities which is important for the
          project to have a long term effect. Past donors to these schools have
          also come forward in helping us with certain parts of the project, but
          one of the major tasks at hand is to raise the funding that we need.
          We will be able to monitor the project and provide continuous guidance
          in any maintenance and improvements with the aid of these
          stakeholders.
        </p>
      </div>
    </Layout>
  )
}
